<template>
    <div class="container">
        <div class="card">
            <div class="card-body p-2">
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <input v-model.trim="keyword"  type="text" class="form-control" maxlength="100" spellcheck=false :placeholder="placehd"></input>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="keyword" class="list" :style="{height:wrapperHeight + 'px'}">
            <div class="wrapper" ref="wrapper">
                <div class="card">
                    <ul class="list-group list-group-flush border-bottom-0">
                        <li class="list-group-item p-2" v-for="item in getMailGroupMemberSelected" :key="item.id">
                            <group-row :type="groupType" :item="item"></group-row>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GroupRow from './GroupRow'
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            GroupRow
        },
        data () {
            return {
                keyword: '',
                time: null,
                wrapperHeight: $(window).height() - 167,
            }
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        watch: {
            keyword () {
                if (!this.keyword) {
                    this.resetMailGroupMemberSelected()
                    this.$parent.showMemberList()
                    return
                }

                this.$parent.hideMemberList()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    if (this.groupType == 'user') {
                        result = this.getMailGroupMember.data.group_members.filter((item)=>
                               String(item.first_nm + item.last_nm).indexOf(this.keyword) != -1
                            || String(item.first_kana + item.last_kana).indexOf(this.keyword) != -1
                            || item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                            || item.user_group.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                        )
                    }
                    if (this.groupType == 'partner') {
                        result = this.getMailGroupMember.data.group_members.filter((item)=>
                               item.user_group.toLowerCase().indexOf(this.keyword) != -1
                            || item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                            || item.email_lev.indexOf(this.keyword.toLowerCase()) != -1
                        )
                    }
                    this.setMailGroupMemberSelected(result)

                }, 100)
            }
        },
        computed: {
            placehd () {
                if (this.groupType == 'user') {
                    return "名前 / User名 / Userグループ"
                }
                if (this.groupType == 'partner') {
                    return "会社名 / Group / Lev"
                }
                return ""
            },
            groupType () {
                return this.getMailGroupMember.data.group_type
            },
            hasNoSearchData () {
                return !this.getMailGroupMemberSelected.length
            },
            ...mapGetters(['getMailGroupMember', 'getMailGroupMemberSelected'])
        },
        methods: {
            setMailGroupMemberSelected (list) {
                this.$store.dispatch('setMailGroupMemberSelected', list)
            },
            resetMailGroupMemberSelected () {
                this.$store.dispatch('resetMailGroupMemberSelected')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0
</style>
